import React, { createContext, useContext } from "react";

interface TabContextType {
  currentActiveTab: string;
  onChange: (value: string) => void;
}

const TabContext = createContext<TabContextType | undefined>(undefined);

export const TabProvider = ({
  children,
  currentActiveTab,
  onChange,
}: {
  children: React.ReactNode;
  currentActiveTab: string;
  onChange: (value: string) => void;
}) => {
  return (
    <TabContext.Provider value={{ currentActiveTab, onChange }}>
      {children}
    </TabContext.Provider>
  );
};

export const useTab = () => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error("useTab must be used within a TabProvider");
  }
  return context;
};
